<template>
  <div class="payment_groups">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-button size="small" type="primary" @click="openAddGroup"
          >添加支付分组</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="dataList" v-loading="loading">
      <el-table-column prop="id" label="ID"></el-table-column>
      <el-table-column prop="name" label="分组名称"></el-table-column>
      <el-table-column prop="weight" label="分组权重"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗 -->
    <!-- 添加分组弹窗 -->
    <PaymentAddGroup
      :visible="visibleAddGroup"
      v-model="dialogInfo"
      :type="dialogType"
      @close="visibleAddGroup = false"
      @refresh="getGroups"
    ></PaymentAddGroup>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import http, { getApiData, api, delData } from '@/http.js'
import PaymentAddGroup from '@/components/payment/PaymentAddGroup'

export default {
  components: {
    PaymentAddGroup
  },
  data() {
    return {
      activeName: 'all',
      loading: false,
      visibleAddGroup: false,//添加分组弹窗显示标志
      visibleControl: false,//支付控制弹窗显示标志
      visibleEdit: false,//编辑弹窗显示标志
      dataList: undefined,//数据列表
      query: {
        page: 1,
        show_type: undefined,
        category_id: undefined
      },
      dialogType:1,//弹窗类型
      dialogInfo:undefined,//弹窗数据
      dataMeta: undefined,//底部分页数据
    }
  },
  computed: {
    ...mapState({
    })
  },
  created() {
    this.getGroups()//获取分组
  },
  methods: {
    ...mapActions(['getPaymentList', 'getPaymentSetting']),
    getGroups() {
      //获取分组列表
      getApiData(`pay_category`)
        .then(
          res => {
            this.dataList = res
          }
        )
    },
    openAddGroup() {
      //添加分组弹窗
      this.visibleAddGroup = true
      this.dialogType=1
    },
    handleEdit(rowInfo){
      //分组编辑
      this.visibleAddGroup = true
      this.dialogType=2
      this.dialogInfo=JSON.parse(JSON.stringify(rowInfo))
    }
  }
}
</script>
